import { resolveBrandPalette } from "./brand-colors";
import { getWhiteLabelKey } from "./white-label";
import { createDarkTheme, createLightTheme } from "../utils/themes/themes";

/** Active white-label key from REACT_APP_WHITE_LABEL (defaults to "default"). */
export function getAppBrandPresetKey() {
  return getWhiteLabelKey();
}

let cachedBrand = null;
let cachedLightTheme = null;
let cachedDarkTheme = null;
let cachedPresetKey = null;

/** Resolved brand palette for this app session (REACT_APP_WHITE_LABEL → default). */
export function getAppBrand() {
  const presetKey = getWhiteLabelKey();
  if (!cachedBrand || cachedPresetKey !== presetKey) {
    cachedBrand = resolveBrandPalette(presetKey);
    cachedPresetKey = presetKey;
    cachedLightTheme = null;
    cachedDarkTheme = null;
  }
  return cachedBrand;
}

export function getAppLightTheme() {
  getAppBrand();
  cachedLightTheme ??= createLightTheme(cachedBrand);
  return cachedLightTheme;
}

export function getAppDarkTheme() {
  getAppBrand();
  cachedDarkTheme ??= createDarkTheme(cachedBrand);
  return cachedDarkTheme;
}

export function getAppTheme(isDarkMode) {
  return isDarkMode ? getAppDarkTheme() : getAppLightTheme();
}
